import React, {useEffect, useState} from "react";
import Sidebar from "../../components/Messages/SideBar";
import ChatHeader from "../../components/Messages/chatHeader";
import ChatMessages from "../../components/Messages/chatMessages";
import MessageInput from "../../components/Messages/messageInput";
import {useChatRoom, useChatRooms} from "../../../hooks/useChat";
import Loader from "../../components/shared/Loader";
import useSocket from "../../../socket/useSocket";
import {socket} from "../../../socket/socket";
import {useMe} from "../../../hooks/useGetUser";
import MainChat from "../../components/Messages/MainChat";
import {useLocation, useNavigate} from "react-router-dom";
import {userRoleList} from "../../../utils/constants";
import noMessage from "../../../images/noMessages.jpg";
import {useOfferMessages} from "../../../hooks/useOfferMessages";
import {useQueryClient} from "@tanstack/react-query";
import {getLatestConversationActivity} from "../../../utils/chatPreview";

const ChatPage = () => {
  const {data: user, isLoading: isMeLoading} = useMe();
  const location = useLocation();

  const {data, isLoading, isError} = useChatRooms();

  const [conversations, setConversations] = useState([
    // Autres conversations
  ]);
  const [emptyConversation, setEmptyConversation] = useState();

  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    return window.innerWidth < 1024; // Example: true if screen width is less than 768px
  });
  const [selectedConversation, setSelectedConversation] = useState();

  // const {messageLocalList, messageLoading} = useOfferMessages({
  //   socket,
  //   selectedConversation,
  // });
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  useEffect(() => {
    const refreshConversations = ({roomId, read} = {}) => {
      if (
        roomId &&
        !read &&
        Number(roomId) === Number(selectedConversation?.id)
      ) {
        socket.emit("mark_room_read", roomId);
      }
      queryClient.invalidateQueries({queryKey: ["chatRooms"]});
    };
    socket.on("chat_room_updated", refreshConversations);
    return () => socket.off("chat_room_updated", refreshConversations);
  }, [queryClient, selectedConversation?.id]);
  useEffect(() => {
    if (data?.length) {
      let filteredData = data
        .filter((el) => !!el?.Technician || !!el?.Client)
        .sort((a, b) => {
          const dateA = new Date(getLatestConversationActivity(a).createdAt);
          const dateB = new Date(getLatestConversationActivity(b).createdAt);
          return dateB - dateA;
        });

      let selected = null;

      if (!!location.hash) {
        selected =
          filteredData.find((el) => location.hash === "#" + String(el.id)) ??
          filteredData[0];
        setSelectedConversation(selected);
        if (window.innerWidth < 1024) {
          setIsSidebarOpen(false);
        }
      } else {
        selected = filteredData[0];
        navigate(`#${selected?.id}`);
        // setSelectedConversation(selected);
      }

      // Move the selected conversation to the front

      setConversations(filteredData);
    }
  }, [data, location]);

  if (isLoading || isMeLoading) {
    // Loading chat
    return <Loader />;
  }

  return (
    <div className="flex h-full bg-white">
      {/* Button to toggle sidebar on small screens */}

      {/* Sidebar overlay */}
      <div
        className={`fixed inset-0 z-40 bg-black bg-opacity-20 transition-opacity duration-300 lg:hidden ${
          isSidebarOpen ? "opacity-20 visible" : "opacity-0 invisible"
        }`}
        onClick={() => setIsSidebarOpen(false)} // Close overlay when clicked
      ></div>

      {/* Sidebar component */}

      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        conversations={conversations}
        selectedConversation={selectedConversation}
        onSelectConversation={setSelectedConversation}
        user={user}
      />

      {/* Main chat area */}
      {!!conversations && !!conversations.length && !!selectedConversation ? (
        <MainChat
          // messageLoading={messageLoading}
          // messageLocalList={messageLocalList}
          emptyConversation={emptyConversation}
          setEmptyConversation={setEmptyConversation}
          setConversations={setConversations}
          // conversations={conversations}
          setIsSidebarOpen={setIsSidebarOpen}
          selectedConversation={selectedConversation}
          user={user}
        />
      ) : (
        <div className="flex flex-col gap-2 justify-center items-center w-full">
          <img src={noMessage} className=" w-[30%] " alt="no_messages" />
        </div>
      )}
    </div>
  );
};

export default ChatPage;
